import type { RouteLocationRaw, RouteMeta } from 'vue-router'

import { Module } from '@/enums/module'
import { useAppStore } from '@/stores/app'

/*
 * WHO MAY OPEN WHICH PAGE, and where a person lands (docs/API.md → Permissions).
 *
 * A route names the module it belongs to (`meta.module`) or that it is a portal
 * administrator's (`meta.requiresAdmin`); everything else — the profile — is anybody's. The
 * answers need the person's modules, which arrive with GET /me: before that nothing can be
 * told, and `routeAllowed` says yes rather than guess (the router and App.vue ask again once
 * /me is in).
 */
export const routeAllowed = (meta: RouteMeta): boolean => {
    const appStore = useAppStore()

    if (!appStore.userData) return true
    if (meta.requiresAdmin && !appStore.isPortalAdmin()) return false
    if (meta.module && !appStore.hasModule(meta.module)) return false

    return true
}

/*
 * THE LANDING PAGE: Naloge's overview for whoever has Naloge, else the profile — the one page
 * everybody has. Until /me is in it is Naloge's, the old landing; the access check corrects it
 * the moment the modules are known.
 */
export const landingRoute = (): RouteLocationRaw => {
    const appStore = useAppStore()

    if (!appStore.userData || appStore.hasModule(Module.Naloge)) return { name: 'dashboard' }

    return { name: 'profile' }
}
